(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  document.documentElement.classList.add('js');
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  };
  const toast = (message) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(window.joyToast);
    window.joyToast = setTimeout(() => el.classList.remove('is-visible'), 2400);
  };

  class CartDrawer {
    constructor() {
      this.drawer = $('[data-cart-drawer]');
      if (!this.drawer) return;
      $$('[data-cart-open]').forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); this.open(); }));
      $$('[data-drawer-close]', this.drawer).forEach((el) => el.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      this.drawer.addEventListener('click', (e) => {
        const button = e.target.closest('[data-cart-change]');
        if (button) this.change(Number(button.dataset.line), Number(button.dataset.quantity));
        const remove = e.target.closest('[data-cart-remove]');
        if (remove) this.change(Number(remove.dataset.line), 0);
      });
    }
    async getCart() {
      const response = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js');
      return response.json();
    }
    async open() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      await this.render();
      $('.drawer__panel', this.drawer)?.focus();
    }
    close() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    }
    async change(line, quantity) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      await this.render();
    }
    async render() {
      const cart = await this.getCart();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
      const heading = $('[data-cart-count-heading]', this.drawer);
      if (heading) heading.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      const body = $('[data-cart-items]', this.drawer);
      const footer = $('[data-cart-footer]', this.drawer);
      if (!cart.items.length) {
        body.innerHTML = '<div class="empty-state"><h3>Your cart is ready for something joyful.</h3><p>Practical favorites, party-ready style.</p><a class="button" href="/collections/joyserve-all">Start shopping</a></div>';
        footer.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map((item, index) => {
        const image = item.image ? '<img src="' + item.image + '&width=180" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
        return '<div class="cart-item">' + image + '<div><h3><a href="' + item.url + '">' + item.product_title + '</a></h3>' + variant + '<div class="quantity"><button type="button" data-cart-change data-line="' + (index + 1) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease">−</button><input value="' + item.quantity + '" aria-label="Quantity" readonly><button type="button" data-cart-change data-line="' + (index + 1) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div><button class="cart-item__remove" type="button" data-cart-remove data-line="' + (index + 1) + '">Remove</button></div><div class="cart-item__price">' + money(item.final_line_price) + '</div></div>';
      }).join('');
      footer.hidden = false;
      $('[data-cart-subtotal]', footer).textContent = money(cart.total_price);
      const progress = $('[data-shipping-progress]', footer);
      if (progress) {
        const threshold = Number(progress.dataset.threshold);
        const remaining = Math.max(0, threshold - cart.total_price);
        $('[data-shipping-message]', progress).textContent = remaining ? 'You’re ' + money(remaining) + ' away from free shipping.' : 'You unlocked free shipping!';
        $('[data-shipping-bar]', progress).style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
      }
    }
  }
  const cartDrawer = new CartDrawer();

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add], [data-product-form]');
    if (!form) return;
    e.preventDefault();
    const button = $('button[type="submit"]', form);
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Adding…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'Could not add this item.');
      toast('Added to your cart');
      await cartDrawer.open();
    } catch (error) { toast(error.message); }
    finally { if (button) { button.disabled = false; button.textContent = button.dataset.label; } }
  });

  const menuButton = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  menuButton?.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
  });
  const searchButton = $('[data-search-toggle]');
  const searchPanel = $('[data-search-panel]');
  searchButton?.addEventListener('click', () => {
    searchPanel.hidden = !searchPanel.hidden;
    searchButton.setAttribute('aria-expanded', String(!searchPanel.hidden));
    if (!searchPanel.hidden) $('input[type="search"]', searchPanel)?.focus();
  });

  $$('.product-gallery').forEach((gallery) => {
    const thumbs = $$('[data-gallery-thumb]', gallery);
    const stage = $('[data-gallery-stage]', gallery);
    const image = $('img', stage);
    const counter = $('[data-gallery-counter]', gallery);
    let currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    if (!image || !thumbs.length) return;

    const showImage = (index) => {
      currentIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[currentIndex];
      image.src = thumb.dataset.image;
      image.srcset = '';
      image.alt = thumb.dataset.alt || '';
      thumbs.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === currentIndex);
        item.setAttribute('aria-current', itemIndex === currentIndex ? 'true' : 'false');
      });
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + thumbs.length;
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(Number(thumb.dataset.galleryIndex || 0))));
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => showImage(currentIndex - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => showImage(currentIndex + 1));
    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showImage(currentIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showImage(currentIndex + 1); }
    });
    showImage(currentIndex);
  });

  $$('[data-product-form]').forEach((form) => {
    const select = $('select[name="id"]', form);
    const price = $('[data-product-price]');
    const submit = $('button[type="submit"]', form);
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (submit) { submit.disabled = option.dataset.available !== 'true'; submit.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out'; }
      const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
    });
  });

  $$('[data-quantity]').forEach((wrap) => {
    const input = $('input', wrap);
    $$('button', wrap).forEach((button) => button.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.step));
    }));
  });

  $('[data-sort-by]')?.addEventListener('change', (e) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.target.value);
    location.href = url.toString();
  });

  $$('[data-predictive-search]').forEach((root) => {
    const input = $('input[type="search"]', root);
    const results = $('[data-predictive-results]', root);
    if (!input || !results) return;
    let timer;
    let controller;

    const close = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const search = async () => {
      const term = input.value.trim();
      if (term.length < 2) { close(); return; }
      controller?.abort();
      controller = new AbortController();
      results.hidden = false;
      results.innerHTML = '<div class="predictive-search__loading">Finding joyful matches…</div>';
      input.setAttribute('aria-expanded', 'true');
      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const url = rootUrl + 'search/suggest?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search is temporarily unavailable.');
        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const section = parsed.querySelector('#shopify-section-predictive-search');
        results.innerHTML = section ? section.innerHTML : markup;
      } catch (error) {
        if (error.name !== 'AbortError') results.innerHTML = '<div class="predictive-search__empty">Search is taking a break. Press Enter to see full results.</div>';
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(search, 180);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowDown' && !results.hidden) {
        const firstResult = $('a', results);
        if (firstResult) { event.preventDefault(); firstResult.focus(); }
      }
    });
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); input.focus(); } });
    document.addEventListener('pointerdown', (event) => { if (!root.contains(event.target)) close(); });
  });

  const progress = $('[data-scroll-progress]');
  let scrollFrame;
  const updateScrollEffects = () => {
    scrollFrame = null;
    if (progress) {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, window.scrollY / max) : 0) + ')';
    }
    $$('[data-parallax-scene]').forEach((scene) => {
      const rect = scene.getBoundingClientRect();
      const scrollOffset = Math.max(-1, Math.min(1, (window.innerHeight * .5 - (rect.top + rect.height * .5)) / window.innerHeight));
      $$('[data-parallax-depth]', scene).forEach((element) => {
        const depth = Number(element.dataset.parallaxDepth || 0);
        element.style.setProperty('--motion-scroll', (scrollOffset * depth * .55) + 'px');
      });
    });
  };
  const requestScrollEffects = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScrollEffects); };
  window.addEventListener('scroll', requestScrollEffects, { passive: true });
  window.addEventListener('resize', requestScrollEffects);
  updateScrollEffects();

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    const revealItems = $$('.section-heading, .category-card, .product-card, .value-item, .editorial, .newsletter, .about-values__grid article, .faq-list details');
    revealItems.forEach((item) => item.classList.add('reveal-item'));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); } });
    }, { threshold: .08, rootMargin: '0px 0px -35px' });
    revealItems.forEach((item) => observer.observe(item));

    if (window.matchMedia('(pointer: fine)').matches) {
      $$('[data-parallax-scene]').forEach((scene) => {
        scene.addEventListener('pointermove', (event) => {
          const rect = scene.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - .5) * 2;
          const y = ((event.clientY - rect.top) / rect.height - .5) * 2;
          $$('[data-parallax-depth]', scene).forEach((element) => {
            const depth = Number(element.dataset.parallaxDepth || 0);
            element.style.setProperty('--motion-x', (x * depth) + 'px');
            element.style.setProperty('--motion-y', (y * depth) + 'px');
          });
        });
        scene.addEventListener('pointerleave', () => {
          $$('[data-parallax-depth]', scene).forEach((element) => {
            element.style.setProperty('--motion-x', '0px');
            element.style.setProperty('--motion-y', '0px');
          });
        });
      });
    }
  }

  $$('[data-about-tabs]').forEach((tabs) => {
    const buttons = $$('[data-about-tab]', tabs);
    const panels = $$('[data-about-panel]', tabs);
    buttons.forEach((button) => button.addEventListener('click', () => {
      const target = button.dataset.aboutTab;
      buttons.forEach((item) => { const selected = item === button; item.classList.toggle('is-active', selected); item.setAttribute('aria-selected', String(selected)); });
      panels.forEach((panel) => { panel.hidden = panel.dataset.aboutPanel !== target; });
    }));
  });

  $$('[data-faq-page]').forEach((faq) => {
    const searchInput = $('[data-faq-search]') || $('[data-faq-search]', faq);
    const filters = $$('[data-faq-filter]', faq);
    const items = $$('[data-faq-item]', faq);
    const empty = $('[data-faq-empty]', faq);
    const count = $('[data-faq-count]', faq);
    let category = 'all';

    const applyFilter = () => {
      const query = (searchInput?.value || '').trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const categoryMatch = category === 'all' || item.dataset.category === category;
        const searchMatch = !query || (item.dataset.searchText || '').includes(query);
        const show = categoryMatch && searchMatch;
        item.hidden = !show;
        if (!show) item.open = false;
        if (show) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = visible + (visible === 1 ? ' answer' : ' answers');
    };

    filters.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.faqFilter;
      filters.forEach((item) => { const selected = item === button; item.classList.toggle('is-active', selected); item.setAttribute('aria-pressed', String(selected)); });
      applyFilter();
    }));
    searchInput?.addEventListener('input', applyFilter);
    items.forEach((item) => item.addEventListener('toggle', () => {
      if (item.open) items.forEach((other) => { if (other !== item) other.open = false; });
    }));
    applyFilter();
  });
})();
